import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'

import {
  GET_FEEDBACKS,
  GET_FEEDBACK,
  GET_FEEDBACK_MANAGERS,
  GET_FEEDBACK_ORDERS,
  UPDATE_FEEDBACK,
  CREATE_FEEDBACK,
  CREATE_SUBFEEDBACK,
  UPDATE_SUBFEEDBACK,
  ATTACH_SUBFEEDBACK_IMAGE,
  GET_SUBFEEDBACK,
} from '@/store/action_types'

import {
  SET_FEEDBACKS,
  SET_FEEDBACK,
  SET_FEEDBACK_MANAGERS,
  SET_FEEDBACK_FILTERS,
  SET_FEEDBACK_ORDERS,
} from '@/store/mutation_types'
import store from '@/store'
import full_name from '@/helpers/full_name'

export default {
  [GET_FEEDBACKS]({ commit, state }, { params = {}, formatter, callback }) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.feedbacks.all}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        let feedbacks = data.data.items

        if (formatter) {
          feedbacks = formatter(feedbacks)
        }

        data.data.filters.end_at = 'between'

        commit(SET_FEEDBACKS, state.feedbacks.concat(feedbacks))
        commit(SET_FEEDBACK_FILTERS, data.data.filters)
        callback ? callback(feedbacks) : null
      }
    })
  },
  [GET_FEEDBACK_ORDERS]({ commit, state }, { params = {}, callback }) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.feedbacks.orders}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        const orders = data.data.items
        commit(SET_FEEDBACK_ORDERS, state.feedbackOrders.concat(orders))
        callback ? callback(orders) : null
      }
    })
  },
  [GET_FEEDBACK]({ commit, state }, { id, params, callback }) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.feedbacks.one.replace('$id', id)}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        const feedback = data.data
        commit(SET_FEEDBACK, feedback)
        callback ? callback(feedback) : null
      }
    })
  },
  [GET_FEEDBACK_MANAGERS]({ commit, state }, { params, formatter, callback }) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.all}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        let feedbackManagers = data.data.items

        if (formatter) {
          feedbackManagers = formatter(feedbackManagers)
        }

        commit(SET_FEEDBACK_MANAGERS, feedbackManagers)
        callback ? callback(feedbackManagers) : null
      }
    })
  },
  [UPDATE_FEEDBACK]({ commit, state }, { id, params = {}, callback }) {
    request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.feedbacks.one.replace('$id', id)}`,
      {
        data: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        // commit(SET_FEEDBACK, data.data);
        snack.add('Отзыв обновлен!', 'primary')
        callback ? callback() : null
      }
    })
  },
  [CREATE_FEEDBACK]({ commit, state }, { params = {}, callback }) {
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.feedbacks.all}`,
      {
        data: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        snack.add('Отзыв создан!', 'primary')
        callback ? callback(data.data) : null
      }
    })
  },
  [CREATE_SUBFEEDBACK]({ commit, state }, { params = {}, callback }) {
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.subfeedbacks.all}`,
      {
        data: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        callback ? callback(data.data) : null
      }
    })
  },
  [UPDATE_SUBFEEDBACK]({ commit, state }, { id, params = {}, callback }) {
    request(
      'PUT',
      `${Vue.config.server}/${Vue.config.modules.crm.api.subfeedbacks.one.replace('$id', id)}`,
      {
        data: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        callback ? callback(data.data) : null
      }
    })
  },
  [GET_SUBFEEDBACK]({ commit, state }, { id, params = {}, callback }) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.subfeedbacks.one.replace('$id', id)}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        callback ? callback(data.data) : null
      }
    })
  },
  [ATTACH_SUBFEEDBACK_IMAGE]({ commit, state }, { id, params = {}, callback }) {
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.subfeedbacks.images.replace('$id', id)}`,
      {
        data: params,
      },
      true,
    ).then(response => {
      const data = response.data
      if (data.result == 'success') {
        callback ? callback(data.data) : null
      }
    })
  },
  async GET_ORDER_BY_HASH({ commit, state }, hash) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.reviews.one.replace('$hash', hash)}`,
        { disableNotifications: true },
        true,
      )
      commit('setOrderByHash', response.data.data)
    } catch (e) {
      console.info(e)
      snack.add('Ошибка')
    }
  },
  async FETCH_FEEDBACK_LIST(context, payload = {}) {
    try {
      const response = await request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.feedbacks.all}`,
        { params: payload },
        true,
      )

      return response.data.data
    } catch (e) {
      console.info(e)
      snack.add(Vue.config.localization.ru.loadingError)
      return { items: [], filters: {} }
    }
  },
}
